module.exports = __webpack_public_path__ + "img/91_bsb.8f81039f.jpg";